;(function() {
  'use strict'

  angular.module('core.imagePrompt', [])
})()
